<div class="content">
  @if (iconName) {
    <div class="icon">
      <cs-icon [name]="iconName"></cs-icon>
    </div>
  }
  <div class="text">
    @if (title) {
      <div class="title">
        {{ title }}
      </div>
    }
    @if (subtext) {
      <div class="subtext">
        {{ subtext }}
      </div>
    }
  </div>
  <div class="buttons">
    <ng-content></ng-content>
  </div>
</div>
